module.exports = __webpack_public_path__ + "img/arrows360image.22895e5f.webp";